import * as React from "react";

// Desktop sidebar yig'ilgan (ikonka-rail) holati. Faqat `lg` va undan katta
// ekranlar uchun — mobil drawer har doim to'liq kenglikda ochiladi.
const STORAGE_KEY = "an_dashboard_sidebar_collapsed";

function getInitial(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(STORAGE_KEY) === "1";
}

export function useSidebarCollapse() {
  const [collapsed, setCollapsed] = React.useState<boolean>(getInitial);

  React.useEffect(() => {
    localStorage.setItem(STORAGE_KEY, collapsed ? "1" : "0");
  }, [collapsed]);

  const toggle = React.useCallback(() => setCollapsed((c) => !c), []);

  return { collapsed, toggle };
}
